/* Nuraxium shared scroll/hover FX + video lightbox — Shopify port.
 * Singleton: safe to load from every section. Idempotent via data-* marks. */
(function () {
  if (window.__nuraxiumFX) { window.__nuraxiumFX.scan(); return; }

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var plxEls = [];
  var revealIO = null;

  if (!reduced && 'IntersectionObserver' in window) {
    revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          var el = en.target;
          var d = parseInt(el.getAttribute('data-rdelay') || '0', 10);
          setTimeout(function () {
            el.style.opacity = '1';
            el.style.transform = 'translateY(0) scale(1)';
          }, d);
          revealIO.unobserve(el);
        }
      });
    }, { threshold: 0.12 });
  }

  function embedUrl(u) {
    try {
      if (u.indexOf('youtu') > -1) {
        var id = '';
        if (u.indexOf('youtu.be/') > -1) { id = u.split('youtu.be/')[1].split(/[?&]/)[0]; }
        else if (u.indexOf('v=') > -1) { id = u.split('v=')[1].split('&')[0]; }
        else if (u.indexOf('/embed/') > -1) { id = u.split('/embed/')[1].split(/[?&]/)[0]; }
        return 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
      }
      if (u.indexOf('vimeo') > -1) {
        var vid = u.split('vimeo.com/')[1].split(/[?&/]/)[0];
        return 'https://player.vimeo.com/video/' + vid + '?autoplay=1';
      }
    } catch (e) {}
    return u;
  }

  function setupLightboxes() {
    document.querySelectorAll('[data-nux-lb]:not([data-lbb])').forEach(function (lb) {
      lb.setAttribute('data-lbb', '1');
      var root = lb.closest('.nux-field') || lb.parentElement || document;
      var body = lb.querySelector('[data-nux-lb-body]');
      function close() {
        lb.classList.remove('is-open');
        lb.setAttribute('aria-hidden', 'true');
        setTimeout(function () { body.innerHTML = ''; lb.style.display = 'none'; }, 260);
        document.documentElement.style.overflow = '';
      }
      function show() {
        lb.style.display = 'flex';
        lb.offsetHeight;
        lb.classList.add('is-open');
        lb.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
      }
      function open(type, src) {
        body.innerHTML = '';
        if (type === 'mp4') {
          var v = document.createElement('video');
          v.src = src; v.controls = true; v.autoplay = true; v.setAttribute('playsinline', '');
          v.addEventListener('ended', close);
          body.appendChild(v); body.style.aspectRatio = '16/9';
        } else if (type === 'embed') {
          var f = document.createElement('iframe');
          f.src = embedUrl(src); f.allow = 'autoplay; fullscreen; picture-in-picture'; f.setAttribute('allowfullscreen', '');
          body.appendChild(f); body.style.aspectRatio = '16/9';
        } else if (type === 'img') {
          var im = document.createElement('img');
          im.src = src; im.alt = ''; body.style.aspectRatio = 'auto';
          body.appendChild(im);
        } else { return; }
        show();
      }
      root.querySelectorAll('[data-nux-report]').forEach(function (card) {
        if (card.dataset.lbc) return;
        card.dataset.lbc = '1';
        card.addEventListener('click', function (e) {
          var t = card.getAttribute('data-vtype');
          if (t === 'none') return;
          e.preventDefault();
          open(t, card.getAttribute('data-vsrc'));
        });
      });
      lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
      var btn = lb.querySelector('[data-nux-lb-close]');
      if (btn) btn.addEventListener('click', close);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && lb.classList.contains('is-open')) close(); });
    });
  }

  // Sticky-stack activation (mobile Shelves): the dominant card in view gets
  // the effect. Fires as soon as a card's top crosses ~55% of the viewport —
  // not only once it's fully pinned — so the FX reads while you scroll.
  function updateStack() {
    var grids = document.querySelectorAll('.nux-shelvesgrid');
    if (!grids.length) return;
    var vh = window.innerHeight;
    for (var g = 0; g < grids.length; g++) {
      var cards = grids[g].querySelectorAll('.nux-ccard');
      var front = -1;
      for (var i = 0; i < cards.length; i++) {
        var cs = getComputedStyle(cards[i]);
        if (cs.position !== 'sticky') continue; // desktop grid: hover handles FX
        var pin = parseFloat(cs.top) || 0;
        var threshold = Math.max(vh * 0.55, pin + 2);
        if (cards[i].getBoundingClientRect().top <= threshold) front = i;
      }
      for (var k = 0; k < cards.length; k++) {
        var on = k === front;
        if (cards[k].classList.contains('nux-active') !== on) {
          cards[k].classList.toggle('nux-active', on);
          if (cards[k].__nuxRoll) cards[k].__nuxRoll(on);
        }
      }
    }
  }

  function scan() {
    if (revealIO) {
      var vh = window.innerHeight;
      document.querySelectorAll('[data-reveal]:not([data-rv])').forEach(function (el) {
        el.setAttribute('data-rv', '1');
        var r = el.getBoundingClientRect();
        if (r.top > vh * 0.92) {
          el.style.opacity = '0';
          el.style.transform = 'translateY(30px) scale(.985)';
          el.style.transition = 'opacity .8s cubic-bezier(.2,.85,.25,1), transform .8s cubic-bezier(.2,.85,.25,1)';
          revealIO.observe(el);
        }
      });
    }
    if (!reduced) {
      document.querySelectorAll('[data-cascade]:not([data-casc])').forEach(function (el) {
        el.setAttribute('data-casc', '1');
        var text = el.textContent;
        el.textContent = '';
        el.setAttribute('aria-label', text);
        var line = document.createElement('span');
        line.style.cssText = 'display:inline-flex;overflow:hidden;height:1.06em;vertical-align:bottom';
        line.setAttribute('aria-hidden', 'true');
        var chars = [];
        for (var i = 0; i < text.length; i++) {
          var c = document.createElement('span');
          c.textContent = text[i] === ' ' ? ' ' : text[i];
          c.style.cssText = 'display:inline-block;position:relative;will-change:transform;text-shadow:0 1.06em currentColor;transition:transform .34s cubic-bezier(.3,.7,.3,1);transition-delay:' + (i * 20) + 'ms';
          line.appendChild(c);
          chars.push(c);
        }
        el.appendChild(line);
        var host = el.closest('.nux-ccard') || el;
        (function (chs) {
          var roll = function (on) { chs.forEach(function (c) { c.style.transform = on ? 'translateY(-1.06em)' : 'translateY(0)'; }); };
          host.__nuxRoll = roll;
          // Hover-roll only on real hover devices; on touch the scroll-driven
          // stack activation (__nuxRoll) owns the effect.
          host.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) roll(true); });
          host.addEventListener('mouseleave', function () { if (window.matchMedia('(hover: hover)').matches) roll(false); });
        })(chars);
      });
    }
    if (!reduced) {
      document.querySelectorAll('[data-magnet]:not([data-mag])').forEach(function (el) {
        el.setAttribute('data-mag', '1');
        el.style.transition = 'transform .25s cubic-bezier(.2,.85,.25,1)';
        el.addEventListener('mousemove', function (e) {
          var r = el.getBoundingClientRect();
          var x = (e.clientX - r.left - r.width / 2) / r.width;
          var y = (e.clientY - r.top - r.height / 2) / r.height;
          el.style.transform = 'translate(' + (x * 8).toFixed(1) + 'px,' + (y * 6).toFixed(1) + 'px)';
        });
        el.addEventListener('mouseleave', function () { el.style.transform = 'translate(0,0)'; });
      });
    }
    document.querySelectorAll('[data-parallax]:not([data-plx])').forEach(function (el) {
      el.setAttribute('data-plx', '1');
      el.dataset.baseTransform = el.style.transform || '';
      plxEls.push(el);
    });
    setupLightboxes();
  }

  function loop() {
    if (!reduced) {
      var vh = window.innerHeight;
      plxEls.forEach(function (el) {
        if (!el.isConnected) return;
        var r = el.getBoundingClientRect();
        var center = r.top + r.height / 2 - vh / 2;
        var speed = parseFloat(el.getAttribute('data-parallax') || '0.05');
        el.style.transform = el.dataset.baseTransform + ' translateY(' + (-center * speed).toFixed(1) + 'px)';
      });
    }
    updateStack();
    requestAnimationFrame(loop);
  }
  requestAnimationFrame(loop);

  window.__nuraxiumFX = { scan: scan };
  scan();
  var n = 0, t = setInterval(function () { n++; scan(); if (n > 20) clearInterval(t); }, 400);
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:select', scan);
})();
